import React from "react";
import { useModal } from "../../context/ModalContext";
import fullLogo from "../../assets/images/svg/logoFullVertical.svg";
import Image from "../Image";
import Button from "../Button";

import "../../assets/styles/components/modals/ModalAnamnesisRenew.css";

const ModalAnamnesisRenew = ({ data }) => {
  const { closeModal } = useModal();

  if (!data) return null;

  const type = data.type || "adulto";
  const icon = data.icon || fullLogo;

  const handleRenew = () => {
    try {
      if (typeof data.onRenew === "function") {
        data.onRenew();
      }
    } catch (e) {
      console.error("Erro no callback onRenew do modal de anamnese:", e);
    }
    closeModal();
  };

  const handleKeep = () => {
    try {
      if (typeof data.onKeep === "function") {
        data.onKeep(type);
      } else {
        // Redirecionamento padrão conforme o tipo
        let target = "/solucoes-purissima";
        if (type === "my-baby") target = "/solucoes-baby";
        else if (type === "my-kids") target = "/solucoes-kids";
        window.location.href = target;
      }
    } catch (e) {
      console.error("Erro no callback onKeep do modal de anamnese:", e);
    }
    // Em caso de redirecionamento por window.location, este close é inofensivo
    closeModal();
  };

  return (
    <div className="ModalAnamnesisRenew" style={{ backgroundColor: "#E6DDCE" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-auto">
            <Image image="trio-anamnese.png" />
          </div>
        </div>
        <div className="row justify-content-center align-items-center">
          <div className="col-12 col-lg-11 text-center">
            <h3 className="m-0">
              <strong>Atualizar sua anamnese?</strong>
            </h3>
            <p className="my-3 my-lg-4">
              A cada 90 dias a Puríssima solicita uma atualização de anamnese, de forma a permitir que sua fórmula possa sempre acompanhar sua evolução.
            </p>

            <div className="box-content mt-4">
              <div className="row justify-content-center brandon">
                <div className="col-lg-10 px-0">
                  <Button
                    label="RENOVAR ANAMNESE"
                    classes="w-100"
                    onClick={handleRenew}
                  />
                </div>
                <div className="col-lg-10 px-0 mt-3">
                  <Button
                    label="NADA SIGNIFICATIVO MUDOU"
                    classes="btn-light-brown w-100"
                    onClick={handleKeep}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAnamnesisRenew;
